import { StyledTooltip } from "../SchoolProfileView/SchoolProfileView.styled";
import { HelpIcon } from "./TooltipModules";
import React from "react";

export const InfoTooltip = ({ content }) => (
  <StyledTooltip title={content}>
    <div>
      <HelpIcon width="25px" height="25px" />
    </div>
  </StyledTooltip>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/InfoTooltip/InfoTooltip.js